/**
 * @generated SignedSource<<41052158e4eae7a6078e368fcab9d596>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acceptingNewPatients"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "legalContractLineOfServiceId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locationId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providesHomeVisits"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providesOfficeVisits"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providesTelehealth"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showInDirectory"
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FacilityLocationMutationGroup",
    "kind": "LinkedField",
    "name": "facilityLocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "acceptingNewPatients",
                "variableName": "acceptingNewPatients"
              },
              {
                "kind": "Variable",
                "name": "effectiveFrom",
                "variableName": "effectiveFrom"
              },
              {
                "kind": "Variable",
                "name": "effectiveTo",
                "variableName": "effectiveTo"
              },
              {
                "kind": "Variable",
                "name": "facilityId",
                "variableName": "facilityId"
              },
              {
                "kind": "Variable",
                "name": "legalContractLineOfServiceId",
                "variableName": "legalContractLineOfServiceId"
              },
              {
                "kind": "Variable",
                "name": "locationId",
                "variableName": "locationId"
              },
              {
                "kind": "Variable",
                "name": "providesHomeVisits",
                "variableName": "providesHomeVisits"
              },
              {
                "kind": "Variable",
                "name": "providesOfficeVisits",
                "variableName": "providesOfficeVisits"
              },
              {
                "kind": "Variable",
                "name": "providesTelehealth",
                "variableName": "providesTelehealth"
              },
              {
                "kind": "Variable",
                "name": "showInDirectory",
                "variableName": "showInDirectory"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "FacilityLocationModifyPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityLocation",
            "kind": "LinkedField",
            "name": "facilityLocation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewFacilityLocationModalMutation",
    "selections": (v10/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewFacilityLocationModalMutation",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "226d5074a5f409dfc06bcf6e60d64ef8",
    "id": null,
    "metadata": {},
    "name": "NewFacilityLocationModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewFacilityLocationModalMutation(\n  $facilityId: ID!\n  $locationId: ID!\n  $legalContractLineOfServiceId: ID!\n  $showInDirectory: Boolean!\n  $acceptingNewPatients: YesNoUnknown!\n  $providesTelehealth: YesNoUnknown!\n  $providesOfficeVisits: YesNoUnknown!\n  $providesHomeVisits: YesNoUnknown!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    create(input: {facilityId: $facilityId, locationId: $locationId, legalContractLineOfServiceId: $legalContractLineOfServiceId, showInDirectory: $showInDirectory, providesTelehealth: $providesTelehealth, acceptingNewPatients: $acceptingNewPatients, providesHomeVisits: $providesHomeVisits, providesOfficeVisits: $providesOfficeVisits, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocation {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "63e6354be88d0c7dad2bbb33b22c29a3";

export default node;
